import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import styles from '../sass/style.module.scss';

export default function Spinner({ className }) {
  const { whiteLabelSettings: { secondaryColour } = {} } =
    useWhiteLabelSettings();

  return (
    <div className={`${className || ''} flex items-center justify-center`}>
      <div
        style={{ color: secondaryColour }}
        className={`${styles.spinnerBorder} animate-spin inline-block w-8 h-8 border-4 rounded-full`}
        role="status"
      >
        <span className={styles.visuallyHidden}>Loading...</span>
      </div>
    </div>
  );
}
